import {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/dist/query';
import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { ApiError, ErrorModel } from '../models/error.models';

export const checkIfErrorIsAvoidable = (
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>,
  error: ErrorModel | undefined
) => {
  if (
    error?.error &&
    error.error === ApiError.NotFound &&
    (result.meta?.request.url.includes('/orders/driverLocation') ||
      result.meta?.request.url.includes('/addresses/territoryId'))
  ) {
    return true;
  }

  return false;
};

export const getErrorDescription = (error: ErrorModel) => {
  switch (error.error) {
    case ApiError.CannotAddPurchaseToProvidedOrder:
      return 'errorModal.cannotAddPurchaseToProvidedOrder';
    case ApiError.CannotCancelNotFinalizedPurchase:
      return 'errorModal.cannotCancelNotFinalizedPurchase';
    case ApiError.CannotDeleteUser:
      return 'errorModal.cannotDeleteUser';
    case ApiError.CartEmpty:
      return 'errorModal.cartEmpty';
    case ApiError.CartItemMissingOrderId:
      return 'errorModal.cartItemMissingOrderId';
    case ApiError.WrongCredentials:
      return 'errorModal.wrongCredentials';
    case ApiError.CartMustReferASingleOrder:
      return 'errorModal.cartMustReferASingleOrder';
    case ApiError.DoorbellTooFarFromAddress:
      return 'errorModal.doorbellTooFarFromAddress';
    case ApiError.FacebookAccountNotMatching:
      return 'errorModal.facebookAccountNotMatching';
    case ApiError.FacebookAccountWithNoEmail:
      return 'errorModal.facebookAccountWithNoEmail';
    case ApiError.FacebookMissingEmailScope:
      return 'errorModal.facebookMissingEmailScope';
    case ApiError.FacebookTokenInvalid:
      return 'errorModal.facebookTokenInvalid';
    case ApiError.FiscalCodeInvalid:
      return 'errorModal.fiscalCodeInvalid';
    case ApiError.FiscalCodeProfileMismatch:
      return 'errorModal.fiscalCodeProfileMismatch';
    case ApiError.Forbidden:
      return 'errorModal.forbidden';
    case ApiError.GoogleAccountNotVerified:
      return 'errorModal.googleAccountNotVerified';
    case ApiError.GoogleAccountWithNoEmail:
      return 'errorModal.googleAccountWithNoEmail';
    case ApiError.GoogleTokenInvalid:
      return 'errorModal.googleTokenInvalid';
    case ApiError.IndaboxPdrLowQuality:
      return 'errorModal.indaboxPdrLowQuality';
    case ApiError.IndaboxPdrTooFarFromDeliveryAddress:
      return 'errorModal.indaboxPdrTooFarFromDeliveryAddress';
    case ApiError.InvalidInput:
      return 'errorModal.invalidInput';
    case ApiError.InvalidOrderStatusForProduct:
      return 'errorModal.invalidOrderStatusForProduct';
    case ApiError.NewAddressMustHaveSameTerritoryId:
      return 'errorModal.newAddressMustHaveSameTerritoryId';
    case ApiError.NotEnoughTimeBeforeEta:
      return 'errorModal.notEnoughTimeBeforeEta';
    case ApiError.NotEnuoghtTimeElapseSinceLastAttempt:
      return 'errorModal.notEnoughTimeElapseSinceLastAttempt';
    case ApiError.NotFound:
      return 'errorModal.notFound';
    case ApiError.NotImplemented:
      return 'errorModal.notImplemented';
    case ApiError.OrderMissingData:
      return 'errorModal.orderMissingData';
    case ApiError.PasswordNotSecure:
      return 'errorModal.passwordNotSecure';
    case ApiError.PasswordResetCodeExpired:
      return 'errorModal.passwordResetCodeExpired';
    case ApiError.PasswordResetWrongCode:
      return 'errorModal.passwordResetWrongCode';
    case ApiError.PayPalCompletingUnkownTransaction:
      return 'errorModal.payPalCompletingUnkownTransaction';
    case ApiError.ProductCanBePurchasedOnlyOncePerOrder:
      return 'errorModal.productCanBePurchasedOnlyOncePerOrder';
    case ApiError.ProductMissingBackendConfiguration:
      return 'errorModal.productMissingConfiguration';
    case ApiError.TokenExpired:
      return 'errorModal.tokenExpired';
    case ApiError.Unauthorized:
      return 'errorModal.unauthorized';
    case ApiError.UniqueProductIsAlreadyInCart:
      return 'errorModal.uniqueProductIsAlreadyInCart';
    case ApiError.UnknownPricingStrategy:
      return 'errorModal.unknownPricingStrategy';
    case ApiError.UnrecognizedPaymentCurrency:
      return 'errorModal.unrecognizedPaymentCurrency';
    case ApiError.ServerError:
      return 'errorModal.serverError';
    case ApiError.orderDoesNotBelongToCustomer:
      return 'errorModal.orderDoesNotBelongToCustomer';
    default:
      return 'errorModal.serverError';
  }
};
